import { Button } from "@mui/material";
// import Markdown from "react-markdown";


export default function Landing(): JSX.Element {
  // const text = `PapyrusAI is a project of the [Digital Learning Lab](https://www.digitallearninglab.org/) at the University of California, Irvine. Our funders include the National Science Foundation (Grant [#23152984](https://www.digitallearninglab.org/gen-ai-in-eng-writing.html)) and UCI Beall Apllied Innovation, the Learning Agency Lab, and the California Education Learning Lab’s AI Grand Challenge. For further information on the project's funding, resources, and research, see the lab's [Generative AI in Education](https://www.genaied.org/) site.`

  return (
    <div className="landing">
      <header className="landing__section-header">
        <a href={"/"} className="landing__section-header__logo" aria-label="PapyrusAI Logo" >
          <span className="for-screen-readers-only">PapyrusAI</span>
          <span className="landing__section-header__logo-dimensions">
            <img src="/dll-logo-noname.png" alt="PapyrusAI logo" />
            <h6 className="landing__section-header__logo-title">PapyrusAI</h6>
          </span>
        </a>
      </header>
      <h3 style={{ marginBottom: "1.5rem", textAlign: "center", width: "100%" }}>Grow your students' writing skills and AI literacy</h3>
      {/* <div style={{ padding: "20px", backgroundColor: "#F78D2D", color: "black", width: "100%", textAlign: "center", fontSize: "1.5rem" }}>
        This is a banner used for updates as needed!
      </div> */}
      <div className="landing__content">
        <div className="landing__column" style={{ alignContent: "center", justifyContent: "center", alignItems: "center" }}>
          <div style={{ alignContent: "center", justifyContent: "space-around", alignItems: "center", width: "100%", display: "flex" }}>
            <Button
              onClick={() => window.location.replace("https://uci.papyrusai.org/")}
              variant="contained"
              size="large"
              style={{ padding: "1rem", marginTop: "1rem", marginBottom: "1rem", width: "45%" }}
            >
              Log In Here for UCI
            </Button>
            <Button
              onClick={() => window.location.replace("https://elsol.papyrusai.org/")}
              variant="contained"
              size="large"
              style={{ padding: "1rem", marginTop: "1rem", marginBottom: "1rem", width: "45%" }}
            >
              Log In Here for El Sol
            </Button>
          </div>
          <div style={{ alignContent: "center", justifyContent: "space-around", alignItems: "center", width: "100%", display: "flex" }}>
            <Button
              onClick={() => window.location.replace("https://pilot.papyrusai.org/")}
              variant="contained"
              size="large"
              style={{ padding: "1rem", marginTop: "1rem", marginBottom: "1rem", width: "45%" }}
            >
              Log In Here for Higher Ed
            </Button>
            <Button
              onClick={() => window.location.replace("https://capousd.papyrusai.org/")}
              variant="contained"
              size="large"
              style={{ padding: "1rem", marginTop: "1rem", marginBottom: "1rem", width: "45%" }}
            >
              Log In Here for Capistrano
            </Button>
          </div>
          <div style={{ alignContent: "center", justifyContent: "space-around", alignItems: "center", width: "100%", display: "flex" }}>
            <Button
              onClick={() => window.location.replace("https://demo.papyrusai.org/")}
              variant="contained"
              size="large"
              style={{ padding: "1rem", marginTop: "1rem", marginBottom: "1rem", width: "45%" }}
            >
              Log In Here for K-12
            </Button>
            <Button
              onClick={() => window.location.replace("https://fll.papyrusai.org/")}
              variant="contained"
              size="large"
              style={{ padding: "1rem", marginTop: "1rem", marginBottom: "1rem", width: "45%" }}
            >
              Log In Here for Fortifying Liberty’s Legacy
            </Button>
          </div>
        </div>
        {/* <div className="landing__column"> */}
        {/* <iframe
            className="landing__video"
            src="https://www.youtube.com/embed/ujLWMISJSDI?si=qNIy4V0ZXCGM_91T"
            title="YouTube video player"
            frameBorder="0"
            data-allow="autoplay; encrypted-media"
            allowFullScreen></iframe> */}

        {/* <div style={{ marginBottom: "1rem", textAlign: "center" }}>
          <Markdown className={""} >
            {text}
          </Markdown>
        </div> */}
      </div>




      &nbsp;&nbsp;&nbsp;

      <h6 style={{ marginBottom: "1rem", textAlign: "center", width: "100%" }}>For more information about PapyrusAI, visit our project page:</h6>
      <div style={{ width: "100%", justifyContent: "center", display: "flex" }}>
        <Button
          onClick={() => window.open("https://www.genaied.org/papyrusai.html", "_blank")}
          variant="contained"
          size="large"
        >
          Generative AI in Education
        </Button>
      </div>

      &nbsp;&nbsp;&nbsp;

      <div className="landing__content">
        <Button href="https://www.papyrusai.org/privacypolicy" target="_blank">Privacy Policy</Button>
        <Button href="https://www.papyrusai.org/termsconditions" target="_blank">Terms and Conditions</Button>
        <Button href="https://drive.google.com/file/d/1JWjpZRa9UQcxf9BWgSvll1mESNB2TagO/view?usp=sharing" target="_blank" rel="noopener noreferrer">Accessibility Conformance Report</Button>
      </div>

    </div>
  )
}